import { path } from 'ramda'
import React from 'react'
import styled, { withTheme } from 'styled-components'

import { Icon, ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { FlightLabel } from '../../../../../src/ui/labels/FlightLabel.jsx'
import ToolTipComponent from '../../../../../src/ui/tooltips/ToolTipComponent.jsx'
import { handleKeyboardSelect } from '../../../../utils/keyboardUtils.js'

import GetDirectionsButton from './GetDirectionsButton.js'

const Wrapper = styled.div`
  padding: 12px 12px 12px 12px;
  box-shadow: inset 0px -1px 0px #EBEBEB;
`

const TopItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const PoiIcon = styled.div`
  margin-right: 14px;
  width: 36px;
  height: 36px;

  &:lang(ar) { margin-right: 0px; margin-left: 14px; }
`

const CloseButton = styled.div`
  cursor: pointer;
`

const StatusWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 50px;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.fontSize('12px')};
  line-height: 18px;

  div {
    margin-left: 8px;
    color: ${({ theme }) => theme.colors.secondaryText};
  }
`

const PoiTitle = styled.div`
  ${({ theme }) => theme.fontSize('20px')};
  color: #333;
  font-weight: 500;
  line-height: 26px;
  flex: 1 1 auto;
`

const SecondaryInfoList = styled.ul`
  list-style: none;
  margin: 8px auto 11px 46px;
  margin-block-start: 0;
  padding-inline-start: 0;
`

const SecondaryInfoElement = styled.li`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.fontSize('14px')};
  line-height: 18px;
  color: ${({ theme }) => theme.colors.secondaryText};

  span:first-of-type {
    min-width: 24px;
    min-height: 24px;
  }

  ${ColoredIcon} {
    margin-right: 5px;
  }
`

const FlightHeader = withTheme(({
  theme,
  className,
  T,
  flightInfo,
  onCloseClicked,
  onGetDirectionClick
}) => {
  if (!flightInfo) return null

  return <Wrapper className={className}>
    <TopItemsWrapper>
      <PoiIcon>
        <Icon id={'gate'} width={36} height={36} />
      </PoiIcon>
      <PoiTitle>
        {flightInfo.name}
      </PoiTitle>
      <ToolTipComponent tooltipText="Close" arrowPosition="left">
        <CloseButton
          aria-label={T('ui:Close')}
          role='button'
          onClick={e => {
            onCloseClicked()
          }}
          tabIndex={'0'}
          onKeyDown={handleKeyboardSelect(() => onCloseClicked())}>
          <ColoredIcon id="close" width={32} height={32} fillColor={theme.colors.secondary} />
        </CloseButton>
      </ToolTipComponent>
    </TopItemsWrapper>
    <StatusWrapper>
      <FlightLabel status={flightInfo.status} statusText={flightInfo.statusText} />
      <div>{flightInfo.lastUpdated}</div>
    </StatusWrapper>
    <SecondaryInfo gate={flightInfo.gate} flightIn={flightInfo.flightIn} />

    {!!flightInfo.gate.poiId && <GetDirectionsButton onGetDirectionClick={onGetDirectionClick} T={T} />}
  </Wrapper>
})

const SecondaryInfo = withTheme(({ gate, flightIn, theme }) => {
  return <SecondaryInfoList>
    {createSecondaryInfoItem(path(['position', 'floorName'], gate), 'levels', theme)}
    {createSecondaryInfoItem(path(['position', 'structureName'], gate), 'building', theme)}
    {createSecondaryInfoItem(flightIn, 'opening-hours', theme)}
  </SecondaryInfoList>
})

const createSecondaryInfoItem = (label, iconId, theme) => !!label &&
  <SecondaryInfoElement>
    <ColoredIcon className="icon" width={24} height={24} id={iconId} fillColor={theme.colors.secondaryText} />
    <span>{label}</span>
  </SecondaryInfoElement>

export default FlightHeader
